import { MontelAccount } from 'domain/account/interfaces';
import { FunctionComponent, ReactNode, createContext, useContext } from 'react';

export type AccountPageContextType = {
	account: MontelAccount;
	refreshAccountData: () => void;
};

export const AccountPageContext = createContext<AccountPageContextType | null>(
	null,
);

const AccountPageContextProvider: FunctionComponent<{
	children: ReactNode;
	account: MontelAccount;
	refreshAccountData: () => void;
}> = ({ children, account, refreshAccountData }) => (
	<AccountPageContext.Provider value={{ account, refreshAccountData }}>
		{children}
	</AccountPageContext.Provider>
);

export function useAccountPageContext() {
	return useContext(AccountPageContext);
}

export default AccountPageContextProvider;
